import { PlaceholderPage } from './PlaceholderPage';

export const UsersAccessPage = () => <PlaceholderPage title="Users & Access" />;
